import React from "react";
import PropTypes from "prop-types";
import { Navigate, Outlet } from "react-router-dom";
import { usePermissions } from "../../contexts/PermissionContext";
import { canManageAnyUser } from "../permissions";

/**
 * Route guard for the add/edit user form.
 *
 * `RequirePermission` gates on a single key, but reaching the form takes
 * user.edit_profile *and* one of the user.manage_* grants. team.view alone —
 * which is all the /account section itself requires — lets a viewer read the
 * user list, not create or edit users, so the form needs its own guard to stop
 * a hand-typed /account/add-user URL.
 */
const RequireUserManagement = ({ redirectTo = "/unauthorized" }) => {
  const { hasPermission, loading } = usePermissions();

  if (loading) return null;

  return canManageAnyUser(hasPermission) ? (
    <Outlet />
  ) : (
    <Navigate to={redirectTo} replace />
  );
};

RequireUserManagement.propTypes = {
  redirectTo: PropTypes.string,
};

export default RequireUserManagement;
